import React from 'react';

import { PayOutlet } from 'components';
import { ROUTE_PATH } from 'constants/routes';

export const OperatorRequisitesPage: React.FC = () => (
  <PayOutlet
    payinTo={ROUTE_PATH.OPERATOR.PAYIN_REQUISITES}
    payoutTo={ROUTE_PATH.OPERATOR.PAYOUT_REQUISITES}
  />
);
